import { VehicleType } from '../../../resources/base/models/vehicleTypes';
import { uiDateToApiDate } from '../../../screens/FormPage/utils/formatDate';
import { isEngineElectricOrHybrid } from '../../common/miscUtils';
import { CreateQuoteRequest } from './types';

export const mapCreateQuoteRequest = (
  data: any & { netPriceWithoutOptions: number; milesCustomerId: string; quoteId: string },
  selectedVehicle: any
): CreateQuoteRequest => {
  const { vehicleType, milesCustomerId, quoteId } = data;
  const milesVehicleId = selectedVehicle.externalVehicleIdentifiers[0].id;
  const modelDescriptionUsed = data.modelName === data.modelDescription ? data.modelName : data.modelDescription;

  const customerDataBlock = () =>
    quoteId && milesCustomerId
      ? {
          customerData: {
            externalIdentifiers: [
              {
                id: milesCustomerId,
                type: 'MILES_CUSTOMER_ID',
              },
            ],
          },
        }
      : {};

  switch (vehicleType) {
    case VehicleType.USED:
      return {
        vehicleData: {
          vehicleType,
          milesVehicleId,
          vin: data.vin,
          isDemo: !!data.isDemo,
          odometer: parseInt(data.currMileage, 10),
          model: {
            manufacturer: data.brand,
            modelYear: data.model,
            name: data.modelGroup,
            description: modelDescriptionUsed,
            engine: data.engine,
            co2emissions: data.co2emision.toString(),
            licensePlate: data.licensePlate,
            initialRegistrationDate: uiDateToApiDate(data.regDate),
            ...(isEngineElectricOrHybrid(data.engine) && {
              batteryPrice: data?.batteryPrice.toString(),
            }),
          },
        },
        ...customerDataBlock(),
      };
    case VehicleType.STOCK:
      return {
        vehicleData: {
          vehicleType,
          milesVehicleId,
          vin: data.vin,
          isDemo: !!data.isDemo,
          ...(data.currMileage !== undefined &&
            data.isDemo && {
              odometer: parseInt(data.currMileage, 10),
            }),
          model: {
            manufacturer: data.brand,
            modelYear: data.model,
            name: data.modelGroup,
            description: data.modelName,
            co2emissions: parseInt(data.co2emision, 10).toString(),
            engine: data.engine,
            ...(data.regDate &&
              data.isDemo && {
                initialRegistrationDate: uiDateToApiDate(data.regDate),
              }),
            ...(isEngineElectricOrHybrid(data.engine) && {
              batteryPrice: data?.batteryPrice?.toString(),
              options: data.options,
            }),
          },
        },
        ...customerDataBlock(),
      };
    case VehicleType.NEW:
    default:
      return {
        vehicleData: {
          vehicleType,
          milesVehicleId,
          isDemo: !!data.isDemo,
          ...(data.currMileage !== undefined &&
            data.isDemo && {
              odometer: parseInt(data.currMileage, 10),
            }),
          model: {
            manufacturer: data.brand,
            modelYear: data.model,
            name: data.modelGroup,
            description: data.modelName,
            engine: data.engine,
            ...(isEngineElectricOrHybrid(data.engine) && {
              batteryPrice: data?.batteryPrice.toString(),
            }),
            fiscalPower: data?.fiscalPower.toString(),
            co2emissions: parseInt(data.co2emision, 10).toString(),
            catalogPrice: data.netPriceWithoutOptions,
            options: data.options,
          },
        },
        ...customerDataBlock(),
      };
  }
};
